import { ReactElement } from 'react';
import { Trans, useTranslation } from 'next-i18next';
import TitleFlip from '../../helpers/TitleFlip';
import { sanitizeHtml } from '@Hotels-at-Home/hah-fe-core/dist/utils';

const AttuneSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$pages.$home.$attuneSection' });
  const { t: tLink } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$attune' });
  const { t: tCommon } = useTranslation('', { keyPrefix: '$common' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
  const { t: tCategory } = useTranslation('', { keyPrefix: '$local.$category' });

  return (
    <section className="base-section attune-section">
      <div className="desktop-viewport">
        <div className="center-block attune">
          <div className="center-block-products">
            <div className="center-block-product-wrap">
              <div data-gsap="fade" data-gsap-delay="0.03" className="stack">
                <h2 data-gsap="fade-up" data-gsap-delay="0.6" className="section-title">
                  <TitleFlip normalText={t('attune')}>
                    <span className="accent-bar">
                      {t('scent')}
                      <em data-gsap="grow" data-gsap-delay="0.85" data-gsap-duration="0.8" />
                    </span>
                  </TitleFlip>
                </h2>
                <p data-gsap="fade-up" data-gsap-delay="0.75" className="txt">
                  {t('centerYourself')}
                </p>
                <p data-gsap="fade-up" data-gsap-delay="0.8" className="txt">
                  <a
                    href={tLink('candle')}
                    aria-label={`${tButton('shopNow')}: ${t('attuneCandle')}`}
                  >
                    <Trans i18nKey="shopCandle" t={t} components={{ span: <span /> }} />
                  </a>
                  <a
                    href={tLink('diffuser')}
                    aria-label={`${tButton('shopNow')}: ${t('attuneDiffuser')}`}
                  >
                    <Trans i18nKey="shopDiffuser" t={t} components={{ span: <span /> }} />
                  </a>
                </p>
              </div>
            </div>

            <div className="center-block-product-wrap">
              <a href={tLink('attune')} aria-label={tCategory('fragrance')}>
                <picture>
                  <source srcSet="/images/homePage/fill.gif" media="(max-width: 800px)" />
                  <source srcSet="/images/homePage/attuneSection/hp-attune-sm.webp" />
                  <img
                    data-gsap="fade"
                    data-gsap-delay="0.4"
                    src="/images/homePage/attuneSection/hp-attune-sm.webp"
                    alt={t('attuneScent')}
                    loading="lazy"
                    width="929"
                    height="581"
                    decoding="async"
                    fetchPriority="low"
                  />
                </picture>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="hp-mobile-viewport">
        <div className="mob-attune">
          <h2 className="mob-title">
            <TitleFlip normalText={t('attune')}>
              <span className="accent-bar">
                {t('scent')}
                <em data-gsap="grow" data-gsap-delay="0.06" data-gsap-duration="0.8" />
              </span>
            </TitleFlip>
          </h2>
          <div className="shop-list">
            <a className="shop-list-item" href={tLink('candle')}>
              <picture>
                <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
                <source srcSet="/images/homePage/attuneSection/marriott-attune-candle-mar-600-wl_lrg.webp" />
                <img
                  className="img lazy"
                  src="/images/homePage/attuneSection/marriott-attune-candle-mar-600-wl_lrg.webp"
                  alt={tCommon('productName', { productName: t('attuneCandle') })}
                  loading="lazy"
                  width="1123"
                  height="732"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
              <h3
                className="mob-section mob-section-half-width txt"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(t('attuneCandle')) }}
              />
            </a>
            <a className="shop-list-item" href={tLink('diffuser')}>
              <picture>
                <source srcSet="/images/homePage/fill.gif" media="(min-width: 801px)" />
                <source srcSet="/images/homePage/attuneSection/marriott-attune-scent-diffuser-mar-610-at_lrg.webp" />
                <img
                  className="img lazy"
                  src="/images/homePage/attuneSection/marriott-attune-scent-diffuser-mar-610-at_lrg.webp"
                  alt={tCommon('productName', { productName: t('attuneDiffuser') })}
                  loading="lazy"
                  width="1123"
                  height="732"
                  decoding="async"
                  fetchPriority="low"
                />
              </picture>
              <h3
                className="mob-section mob-section-half-width txt"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(t('attuneDiffuser')) }}
              />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AttuneSection;
